/*
  Limits shared by the Autopilot chat composer (client) and the AgentMessages
  validator (server), so the textarea can never accept a message the server rejects.

  MESSAGE_MAX_LENGTH is sized so a pasted list of ~1,000 creator IDs or usernames
  fits in one message. Hard ceiling: AgentMessages.message is a MySQL TEXT column
  (65,535 bytes) and a UTF-16 code unit can take 3 UTF-8 bytes, so this must stay
  at or below ~21,800.
*/

const MESSAGE_MAX_LENGTH = 20000;

module.exports = {
  MESSAGE_MAX_LENGTH
};
